import { storeToRefs } from "pinia";
import { ref } from "vue";

import useTeamPicker from "shared/composables/useTeamPicker";
import {
  MediaRelease,
  MediaReleasesContactList,
  MediaReleasesContactMailingList,
} from "shared/resources";
import features from "shared/services/features";
import { useUserStore } from "shared/stores/user";

export default function useMediaRelease() {
  const mediaRelease = ref();

  const { currentUser, organisation } = storeToRefs(useUserStore());

  function setDefaultMediaRelease() {
    const { selectedTeamPreference } = useTeamPicker();

    mediaRelease.value = new MediaRelease({
      userId: currentUser.value.id,
      organisationId: organisation.value.id,
      subject: "",
      message: "",
      status: "draft",
      fromName: `${currentUser.value.first_name} ${currentUser.value.last_name}`,
      replyTo: currentUser.value.email,
      ...(features.has("has_team_workspaces")
        ? { organisationTeamId: selectedTeamPreference.value }
        : {}),
    });
  }

  function buildMediaReleaseContactLists(contactListIds = []) {
    const contactLists = [];

    contactListIds.forEach((id) => {
      const newContactList = new MediaReleasesContactList({
        contactListId: id,
      });

      contactLists.push(newContactList);
    });

    return contactLists;
  }

  function buildMediaReleaseContactMailingLists(contactMailingListIds = []) {
    const contactMailingLists = [];

    contactMailingListIds.forEach((id) => {
      const newContactMailingList = new MediaReleasesContactMailingList({
        contactMailingListId: id,
      });

      contactMailingLists.push(newContactMailingList);
    });

    return contactMailingLists;
  }

  return {
    mediaRelease,

    setDefaultMediaRelease,
    buildMediaReleaseContactLists,
    buildMediaReleaseContactMailingLists,
  };
}
